import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class ParametroTimestamp {
  static getByNombre (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.get(
      `parametro_timestamp?r={"clave":{"nombre":"${nombre}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static updateByNombre (nombre, value) {
    const axios = getAxiosInstance()
    const promise = axios.put(`parametro_timestamp`,
      `{"valores": {"valor": "${value}"}, "clave": {"nombre": "${nombre}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static insertParameter (nombre, descripcion, value) {
    const axios = getAxiosInstance()
    const promise = axios.post(`parametro_timestamp`, `{"valores": {"nombre": "${nombre}", "descripcion": "${descripcion}", "valor": "${value}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static deleteParameter (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`parametro_timestamp?r=` +
    `{"clave":{"nombre": "${nombre}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default ParametroTimestamp
